module.exports = __webpack_public_path__ + "static/img/6.c53592d2.png";